/* Portal-only translations & helpers. */
export const PORTAL_T = {
  ar: {
    // Landing
    landing_title: (n) => n,
    landing_sub: "خدمة احترافية، سريعة، وسهلة الاستخدام",
    start: "ابدأ معاملتك",
    track: "تتبع معاملتك",
    coming_soon_note: "تجربة عميل بمعايير رفيعة. اختر ما تريد البدء به.",
    care_note: "وفّرنا عليك عناء المتابعة التقليدية. فريقنا يتابع طلبك باستمرار.",

    // Steps
    step_of: (n, t) => `الخطوة ${n} من ${t}`,
    back: "السابق",
    next: "التالي",
    submit_app: "إرسال الطلب",
    skip: "تخطي",

    // Stage 1
    s1_title: "المعلومات الأساسية",
    nationality: "الحالة",
    nationality_saudi: "مواطن سعودي",
    nationality_non_saudi: "مقيم أو أجنبي",
    applicant_type: "نوع التقديم",
    applicant_individual: "فردي",
    applicant_family: "عائلة",
    applicant_multiple: "متعدد",
    marital: "الحالة الاجتماعية",
    marital_single: "أعزب/عزباء",
    marital_married: "متزوج/ة",
    country: "الدولة المطلوبة",
    country_placeholder: "اكتب اسم الدولة",
    visa_type: "نوع التأشيرة",
    visa_type_placeholder: "اكتب نوع التأشيرة (مثال: دعوة)",
    other_typed: "أخرى — أكتب يدوياً",
    travel_date: "تاريخ السفر",
    full_name: "الاسم الكامل",
    mobile: "رقم الجوال",
    mobile_hint: "مثال: 05XXXXXXXX",

    // Stage 2
    s2_title: "بيانات المسافرين",
    s_combined_title: "بيانات المسافرين والمستندات",
    s_combined_hint: "أضف المسافرين ثم ارفع مستندات كل واحد منهم في نفس المرحلة.",
    sponsor_label: "الكفيل / جهة العمل (اختياري)",
    sponsor_individual: "كفيل (شخص)",
    sponsor_company: "شركة / جهة عمل",
    sponsor_placeholder: "اكتب اسم الكفيل أو الشركة",
    s2_hint_individual: "تقديم فردي — مسافر واحد فقط.",
    s2_hint_family: "أضف جميع المسافرين معك ضمن العائلة.",
    family_simple_note: "اكتب فقط اسم الفرد وصلة القرابة — باقي البيانات تُقرأ تلقائياً من صورة الجواز في الخطوة التالية، أو يكملها الفريق لاحقاً.",
    extra_fields_optional: "+ بيانات إضافية (اختيارية)",
    add_member: "إضافة فرد",
    scan_add_member: "إضافة مسافر بالمسح الذكي",
    smart_scan: "مسح ذكي",
    remove: "حذف",
    member_name: "الاسم الكامل",
    passport_no: "رقم الجواز",
    member_nationality: "الجنسية",
    relationship: "صلة القرابة",
    relation_spouse: "زوج/ة",
    relation_child: "ابن/ابنة",
    relation_parent: "والد/ة",
    relation_sibling: "أخ/أخت",
    relation_self: "نفسه/مقدّم الطلب",
    relation_other: "آخر",

    // Companion (domestic worker) block — Stage 2
    companion_q: "هل لديك عمالة منزلية مرافقة؟",
    companion_hint: "السائق / الطباخة / الخادم / المربية — أي شخص يسافر معك تحت كفالتك.",
    companion_count: "عدد المرافقين",
    companion_card_title: "المرافق",
    companion_full_name: "الاسم الكامل",
    companion_job_title: "الوظيفة",
    companion_job_ph: "اكتب وظيفته (سائق / طباخة / خادم / مربية ...)",
    companion_nationality: "الجنسية",
    companion_iqama: "رقم الإقامة",
    companion_passport: "رقم الجواز",
    companion_dob: "تاريخ الميلاد",
    companion_sex: "الجنس",
    companion_docs_hint: "ارفع صور الجواز والإقامة لهذا المرافق في الخطوة التالية — يقرأها النظام تلقائياً.",
    yes: "نعم",
    no: "لا",

    // Stage 3
    s3_title: "رفع المستندات",
    s3_hint: "يرجى التكرم برفع مستندات أصلية وواضحة وغير معدلة لضمان جودة المعالجة وسرعة تنفيذ الطلب.",
    drop_file: "اسحب الملف هنا أو انقر للاختيار",
    formats: "PNG / JPG / PDF — حتى 15 ميجا (يتم الضغط تلقائياً)",
    uploaded: "تم الرفع",
    delete_file: "حذف",

    doc_passport: "الجواز",
    doc_national_id: "الهوية الرسمية (أبشر / توكلنا مع QR)",
    doc_residence: "الإقامة الرسمية (أبشر / توكلنا مع QR)",
    doc_bank: "كشف حساب آخر 3 أشهر",
    doc_bank6: "كشف حساب آخر 6 أشهر",
    doc_photo: "صورة شخصية",
    doc_old_visas: "تأشيرات سابقة (اختياري)",
    doc_family_card: "بطاقة العائلة",
    doc_marriage: "عقد الزواج",
    doc_salary: "تعريف راتب",
    doc_exit_return: "تأشيرة خروج وعودة",

    translation_offer: "ترجمة معتمدة من المكتب — 50 ريال",
    optional: "اختياري",
    required: "مطلوب",

    // Stage 4
    s4_title: "الخدمات الإضافية",
    translation_service: "خدمة الترجمة",
    translation_desc: "هل تحتاج ترجمة معتمدة لبطاقة العائلة / عقد الزواج؟",
    translation_choice_none: "لا أحتاج ترجمة",
    translation_choice_none_hint: "المستندات بالعربية أو لا تحتاج ترجمة",
    translation_choice_self: "أرفع ترجمتي بنفسي",
    translation_choice_self_hint: "ترجمة معتمدة من مكتب خارجي — لا رسوم",
    translation_choice_office: "أريد المكتب يترجم",
    translation_choice_office_hint: "ترجمة احترافية من المكتب — 50 ر.س",
    // iOS-style translation notice (informational text — choices live below in the radio cards)
    tn_brand: "المكتب",
    tn_now: "الآن",
    tn_title: "عزيزي العميل — ملاحظة هامة",
    tn_body: "السفارات تتطلب المستندات باللغة الإنجليزية بالكامل. ولأن الهوية / الإقامة / بطاقة العائلة / مكان الميلاد مكتوبة بالعربية، فهي تحتاج ترجمة معتمدة.",
    tn_eta: "تُسلَّم المترجمات في الموعد — وليس الآن.",
    muaqqib_service: "خدمة المعقّب",
    muaqqib_desc: "موظف مخصص يتابع طلبك في مراكز التأشيرات.",
    muaqqib_price_hint: "100 ريال لكل فرد — تُحسب تلقائياً حسب عدد المسافرين",
    persons_count: "عدد الأشخاص",
    member_dob: "تاريخ الميلاد",
    member_exp: "تاريخ انتهاء الجواز",
    member_sex: "الجنس",
    sex_male: "ذكر",
    sex_female: "أنثى",

    // Stage 5
    s5_title: "السياسة والموافقة",
    policy_summary: "ملخّص: المعاملة تخضع لسياسة المكتب. تستلم خدمتك بدقة عالية ووفق الأنظمة. لن نشاركك بياناتك مع طرف ثالث.",
    read_full: "قراءة السياسة كاملة",
    agree: "أقرّ بمراجعتي لسياسة المكتب وأوافق على الشروط والأحكام.",
    must_agree: "يجب الموافقة على السياسة للمتابعة.",

    // Stage 6
    s6_title: "السداد والإرسال",
    bank_name: "البنك",
    account_name: "اسم المستفيد",
    account_number: "رقم الحساب",
    iban: "الآيبان",
    copy: "نسخ",
    copied: "تم النسخ ✓",
    bank_instructions: "تعليمات التحويل",
    amount: "المبلغ المحوّل (ريال)",
    receipt: "إيصال السداد",

    // Success
    success_title: "شكراً لوقتكم الكريم",
    success_body: (name, no) =>
      `عزيزي العميل، تم إرسال النموذج للفريق المختص بنجاح. رقم معاملتك: ${no} — يمكنك تتبع حالة طلبك في أي وقت عبر هذا الرقم.`,
    success_track: "اذهب لتتبع المعاملة",

    // Track
    track_title: "تتبع المعاملة",
    track_input: "رقم المعاملة (مثال: VTA-2026-00001)",
    track_btn: "بحث",
    track_invalid: "رقم المعاملة غير صحيح",
    track_not_found: "لم نتمكن من العثور على هذه المعاملة.",
    track_status: "الحالة الحالية",
    last_update: "آخر تحديث",
    timeline: "سجل المراحل",
    employee_notes: "ملاحظات للعميل",
    appointment_set: "موعدك في مركز التأشيرات",
    fees_set: "رسوم المعاملة",
    no_notes_yet: "لا توجد ملاحظات حالياً. سيتم إشعارك بأي متطلبات إضافية.",

    err_required: "هذا الحقل مطلوب",
    err_uploading: "تعذّر رفع الملف. حاول مرة أخرى.",
    err_too_many: "محاولات كثيرة. الرجاء المحاولة لاحقاً.",
  },
  en: {
    landing_title: (n) => n,
    landing_sub: "Premium service. Fast and effortless.",
    start: "Start application",
    track: "Track application",
    coming_soon_note: "A premium client experience. Pick where to begin.",
    care_note: "We handle the legwork — your application is tracked continuously by our team.",

    step_of: (n, t) => `Step ${n} of ${t}`,
    back: "Back",
    next: "Next",
    submit_app: "Submit application",
    skip: "Skip",

    s1_title: "Basic information",
    nationality: "Status",
    nationality_saudi: "Saudi citizen",
    nationality_non_saudi: "Resident / Foreign",
    applicant_type: "Type",
    applicant_individual: "Individual",
    applicant_family: "Family",
    applicant_multiple: "Multiple",
    marital: "Marital status",
    marital_single: "Single",
    marital_married: "Married",
    country: "Destination",
    country_placeholder: "Type the country name",
    visa_type: "Visa type",
    visa_type_placeholder: "Type the visa type (e.g. invitation)",
    other_typed: "Other — type manually",
    travel_date: "Travel date",
    full_name: "Full name",
    mobile: "Mobile number",
    mobile_hint: "Example: 05XXXXXXXX",

    s2_title: "Travelers",
    s_combined_title: "Travelers & Documents",
    s_combined_hint: "Add the travelers, then upload each one's documents in the same stage.",
    sponsor_label: "Sponsor / Employer (optional)",
    sponsor_individual: "Personal Sponsor",
    sponsor_company: "Company / Employer",
    sponsor_placeholder: "Sponsor or company name",
    s2_hint_individual: "Individual submission — one traveler only.",
    s2_hint_family: "Add every traveler in your family.",
    family_simple_note: "Only the name and the relationship are needed — the rest is read automatically from the passport image on the next step, or completed later by our team.",
    extra_fields_optional: "+ Extra details (optional)",
    add_member: "Add traveler",
    scan_add_member: "Add via Smart Scan",
    smart_scan: "Smart scan",
    remove: "Remove",
    member_name: "Full name",
    passport_no: "Passport number",
    member_nationality: "Nationality",
    relationship: "Relationship",
    relation_spouse: "Spouse",
    relation_child: "Child",
    relation_parent: "Parent",
    relation_sibling: "Sibling",
    relation_self: "Self / main applicant",
    relation_other: "Other",

    // Companion (domestic worker) block — Stage 2
    companion_q: "Do you have any domestic worker travelling with you?",
    companion_hint: "Driver / cook / housemaid / nanny — anyone travelling under your sponsorship.",
    companion_count: "Number of companions",
    companion_card_title: "Companion",
    companion_full_name: "Full name",
    companion_job_title: "Job title",
    companion_job_ph: "Type the job (driver / housemaid / cook / nanny ...)",
    companion_nationality: "Nationality",
    companion_iqama: "Iqama number",
    companion_passport: "Passport number",
    companion_dob: "Date of birth",
    companion_sex: "Sex",
    companion_docs_hint: "Upload passport + iqama photos for this companion in the next step — they will be auto-read.",
    yes: "Yes",
    no: "No",

    s3_title: "Documents",
    s3_hint: "Please upload original, clear, unmodified documents to ensure fast processing.",
    drop_file: "Drop a file here or click to pick",
    formats: "PNG / JPG / PDF — up to 15 MB (auto-compressed)",
    uploaded: "Uploaded",
    delete_file: "Remove",

    doc_passport: "Passport",
    doc_national_id: "National ID (Absher/Tawakkalna with QR)",
    doc_residence: "Residence permit (Absher/Tawakkalna with QR)",
    doc_bank: "Bank statement — last 3 months",
    doc_bank6: "Bank statement — last 6 months",
    doc_photo: "Personal photo",
    doc_old_visas: "Previous visas (optional)",
    doc_family_card: "Family card",
    doc_marriage: "Marriage certificate",
    doc_salary: "Salary certificate",
    doc_exit_return: "Exit & re-entry visa",

    translation_offer: "Office-certified translation — 50 SAR",
    optional: "Optional",
    required: "Required",

    s4_title: "Add-on services",
    translation_service: "Translation",
    translation_desc: "Do you need a certified translation of family card / marriage certificate?",
    translation_choice_none: "Not needed",
    translation_choice_none_hint: "Docs are in Arabic / no translation required",
    translation_choice_self: "I'll provide my own",
    translation_choice_self_hint: "Translated by an external office — no fee",
    translation_choice_office: "Have the office translate",
    translation_choice_office_hint: "Professional translation by us — 50 SAR",
    tn_brand: "Office",
    tn_now: "Now",
    tn_title: "Dear customer — important notice",
    tn_body: "Embassies require all documents in English. National ID / Residence permit / Family card / Place of birth are in Arabic, so a certified translation is needed.",
    tn_eta: "Translations are delivered on appointment day — not now.",
    muaqqib_service: "Muaqqib (Expediter)",
    muaqqib_desc: "Dedicated agent who escorts your application at the visa centre.",
    muaqqib_price_hint: "100 SAR per person — auto-calculated by travelers count",
    persons_count: "Persons count",
    member_dob: "Date of birth",
    member_exp: "Passport expiry",
    member_sex: "Sex",
    sex_male: "Male",
    sex_female: "Female",

    s5_title: "Policy & consent",
    policy_summary: "Summary: your application is governed by our office policy. We protect your data and never share it with third parties.",
    read_full: "Read full policy",
    agree: "I have reviewed the office policy and accept the terms.",
    must_agree: "You must accept the policy to continue.",

    s6_title: "Payment & submit",
    bank_name: "Bank",
    account_name: "Beneficiary",
    account_number: "Account number",
    iban: "IBAN",
    copy: "Copy",
    copied: "Copied ✓",
    bank_instructions: "Transfer instructions",
    amount: "Transferred amount (SAR)",
    receipt: "Payment receipt",

    success_title: "Thank you for your time",
    success_body: (name, no) =>
      `Dear customer, your application has been forwarded to our team successfully. Your number is: ${no} — you can track it anytime using this number.`,
    success_track: "Track my application",

    track_title: "Track application",
    track_input: "Application number (e.g. VTA-2026-00001)",
    track_btn: "Search",
    track_invalid: "Invalid application number",
    track_not_found: "We couldn't find this application.",
    track_status: "Current status",
    last_update: "Last update",
    timeline: "Timeline",
    employee_notes: "Notes from our team",
    appointment_set: "Your appointment at the visa centre",
    fees_set: "Fees",
    no_notes_yet: "No notes yet. We'll notify you if anything is needed.",

    err_required: "Required",
    err_uploading: "Couldn't upload the file. Try again.",
    err_too_many: "Too many attempts. Try again later.",
  },
  ur: {
    landing_title: (n) => n,
    landing_sub: "پریمیم سروس۔ تیز اور آسان۔",
    start: "درخواست شروع کریں",
    track: "درخواست ٹریک کریں",
    coming_soon_note: "ایک پریمیم کلائنٹ تجربہ۔ شروع کرنے کے لیے انتخاب کریں۔",
    care_note: "ہم ساری دوڑ بھاگ سنبھالتے ہیں — آپ کی درخواست کو ہماری ٹیم مسلسل ٹریک کرتی ہے۔",

    step_of: (n, t) => `مرحلہ ${n} از ${t}`,
    back: "پیچھے",
    next: "اگلا",
    submit_app: "درخواست جمع کریں",
    skip: "چھوڑیں",

    s1_title: "بنیادی معلومات",
    nationality: "حالت",
    nationality_saudi: "سعودی شہری",
    nationality_non_saudi: "مقیم / غیر ملکی",
    applicant_type: "قسم",
    applicant_individual: "انفرادی",
    applicant_family: "خاندان",
    applicant_multiple: "متعدد",
    marital: "ازدواجی حیثیت",
    marital_single: "غیر شادی شدہ",
    marital_married: "شادی شدہ",
    country: "ملک",
    country_placeholder: "ملک کا نام لکھیں",
    visa_type: "ویزا کی قسم",
    visa_type_placeholder: "ویزا کی قسم لکھیں (مثلاً: دعوت)",
    other_typed: "دیگر — دستی طور پر لکھیں",
    travel_date: "سفر کی تاریخ",
    full_name: "مکمل نام",
    mobile: "موبائل نمبر",
    mobile_hint: "مثال: 05XXXXXXXX",

    s2_title: "مسافر",
    s_combined_title: "مسافروں کی معلومات اور دستاویزات",
    s_combined_hint: "مسافروں کو شامل کریں، پھر اسی مرحلے میں ہر ایک کی دستاویزات اپ لوڈ کریں۔",
    sponsor_label: "کفیل / آجر (اختیاری)",
    sponsor_individual: "ذاتی کفیل",
    sponsor_company: "کمپنی / آجر",
    sponsor_placeholder: "کفیل یا کمپنی کا نام",
    s2_hint_individual: "انفرادی درخواست — صرف ایک مسافر۔",
    s2_hint_family: "اپنے خاندان کے تمام مسافروں کو شامل کریں۔",
    family_simple_note: "صرف نام اور رشتہ لکھیں — باقی معلومات اگلے مرحلے میں پاسپورٹ کی تصویر سے خودکار طور پر پڑھی جائیں گی، یا ٹیم بعد میں مکمل کرے گی۔",
    extra_fields_optional: "+ اضافی معلومات (اختیاری)",
    add_member: "مسافر شامل کریں",
    scan_add_member: "اسمارٹ سکین کے ذریعے شامل کریں",
    smart_scan: "اسمارٹ سکین",
    remove: "ہٹائیں",
    member_name: "مکمل نام",
    passport_no: "پاسپورٹ نمبر",
    member_nationality: "قومیت",
    relationship: "رشتہ",
    relation_spouse: "شریک حیات",
    relation_child: "بچہ",
    relation_parent: "والدین",
    relation_sibling: "بھائی/بہن",
    relation_self: "خود / مرکزی درخواست گزار",
    relation_other: "دیگر",

    // Companion (domestic worker) block — Stage 2
    companion_q: "کیا آپ کے ساتھ کوئی گھریلو ملازم سفر کر رہا ہے؟",
    companion_hint: "ڈرائیور / باورچی / ملازمہ / آیا — کوئی بھی شخص جو آپ کی کفالت میں سفر کر رہا ہو۔",
    companion_count: "ملازمین کی تعداد",
    companion_card_title: "ملازم",
    companion_full_name: "پورا نام",
    companion_job_title: "نوکری",
    companion_job_ph: "نوکری لکھیں (ڈرائیور / ملازمہ / باورچی / آیا ...)",
    companion_nationality: "قومیت",
    companion_iqama: "اقامہ نمبر",
    companion_passport: "پاسپورٹ نمبر",
    companion_dob: "تاریخ پیدائش",
    companion_sex: "جنس",
    companion_docs_hint: "اگلے مرحلے میں اس ملازم کا پاسپورٹ اور اقامہ اپ لوڈ کریں — یہ خود بخود پڑھے جائیں گے۔",
    yes: "ہاں",
    no: "نہیں",

    s3_title: "دستاویزات",
    s3_hint: "براہ کرم اصل، صاف اور غیر ترمیم شدہ دستاویزات اپ لوڈ کریں تاکہ تیز کارروائی ممکن ہو۔",
    drop_file: "فائل یہاں ڈالیں یا منتخب کرنے کے لیے کلک کریں",
    formats: "PNG / JPG / PDF — 15 MB تک (خودکار طور پر کمپریس)",
    uploaded: "اپ لوڈ ہو گیا",
    delete_file: "ہٹائیں",

    doc_passport: "پاسپورٹ",
    doc_national_id: "قومی شناختی کارڈ (ابشر/توکلنا QR کے ساتھ)",
    doc_residence: "اقامہ (ابشر/توکلنا QR کے ساتھ)",
    doc_bank: "بینک سٹیٹمنٹ — آخری 3 ماہ",
    doc_bank6: "بینک سٹیٹمنٹ — آخری 6 ماہ",
    doc_photo: "ذاتی تصویر",
    doc_old_visas: "سابقہ ویزے (اختیاری)",
    doc_family_card: "خاندانی کارڈ",
    doc_marriage: "نکاح نامہ",
    doc_salary: "تنخواہ کا سرٹیفکیٹ",
    doc_exit_return: "خروج و عودہ ویزا",

    translation_offer: "آفس سے مصدقہ ترجمہ — 50 ریال",
    optional: "اختیاری",
    required: "ضروری",

    s4_title: "اضافی خدمات",
    translation_service: "ترجمہ",
    translation_desc: "کیا آپ کو خاندانی کارڈ / نکاح نامہ کا مصدقہ ترجمہ چاہیے؟",
    translation_choice_none: "ضرورت نہیں",
    translation_choice_none_hint: "دستاویزات عربی میں ہیں / ترجمہ کی ضرورت نہیں",
    translation_choice_self: "میں اپنا ترجمہ خود اپ لوڈ کروں گا",
    translation_choice_self_hint: "بیرونی آفس سے ترجمہ — کوئی فیس نہیں",
    translation_choice_office: "آفس ترجمہ کرے",
    translation_choice_office_hint: "آفس کا پیشہ ورانہ ترجمہ — 50 ریال",
    tn_brand: "آفس",
    tn_now: "ابھی",
    tn_title: "محترم گاہک — اہم اطلاع",
    tn_body: "سفارتخانے تمام دستاویزات انگریزی میں چاہتے ہیں۔ شناختی کارڈ / اقامہ / خاندانی کارڈ / جائے پیدائش عربی میں ہیں، اس لیے مصدقہ ترجمہ ضروری ہے۔",
    tn_eta: "ترجمے اپوائنٹمنٹ والے دن دیے جاتے ہیں — ابھی نہیں۔",
    muaqqib_service: "معقّب (نمائندہ)",
    muaqqib_desc: "ایک مخصوص نمائندہ جو ویزا سینٹر میں آپ کی درخواست کی پیروی کرتا ہے۔",
    muaqqib_price_hint: "ہر شخص کے لیے 100 ریال — مسافروں کی تعداد کے حساب سے خودکار",
    persons_count: "افراد کی تعداد",
    member_dob: "تاریخ پیدائش",
    member_exp: "پاسپورٹ کی میعاد",
    member_sex: "جنس",
    sex_male: "مرد",
    sex_female: "عورت",

    s5_title: "پالیسی اور رضامندی",
    policy_summary: "خلاصہ: آپ کی درخواست ہماری آفس پالیسی کے تحت ہے۔ ہم آپ کا ڈیٹا محفوظ رکھتے ہیں اور اسے کبھی تیسرے فریق کے ساتھ شیئر نہیں کرتے۔",
    read_full: "مکمل پالیسی پڑھیں",
    agree: "میں نے آفس پالیسی کا جائزہ لے لیا ہے اور شرائط قبول کرتا ہوں۔",
    must_agree: "آگے بڑھنے کے لیے پالیسی کو قبول کرنا ضروری ہے۔",

    s6_title: "ادائیگی اور جمع",
    bank_name: "بینک",
    account_name: "مستفید",
    account_number: "اکاؤنٹ نمبر",
    iban: "آئی بان",
    copy: "نقل کریں",
    copied: "نقل ہو گیا ✓",
    bank_instructions: "منتقلی کی ہدایات",
    amount: "منتقل شدہ رقم (ریال)",
    receipt: "ادائیگی کی رسید",

    success_title: "آپ کے قیمتی وقت کا شکریہ",
    success_body: (name, no) =>
      `محترم گاہک، آپ کی درخواست کامیابی سے ہماری ٹیم کو بھیج دی گئی ہے۔ آپ کا نمبر: ${no} — آپ اس نمبر سے کسی بھی وقت ٹریک کر سکتے ہیں۔`,
    success_track: "میری درخواست ٹریک کریں",

    track_title: "درخواست ٹریک کریں",
    track_input: "درخواست نمبر (مثلاً VTA-2026-00001)",
    track_btn: "تلاش",
    track_invalid: "غلط درخواست نمبر",
    track_not_found: "یہ درخواست نہیں ملی۔",
    track_status: "موجودہ حالت",
    last_update: "آخری اپ ڈیٹ",
    timeline: "ٹائم لائن",
    employee_notes: "ہماری ٹیم کے نوٹس",
    appointment_set: "ویزا سینٹر میں آپ کی اپوائنٹمنٹ",
    fees_set: "فیس",
    no_notes_yet: "ابھی کوئی نوٹس نہیں۔ اگر کچھ درکار ہوا تو ہم اطلاع دیں گے۔",

    err_required: "ضروری",
    err_uploading: "فائل اپ لوڈ نہیں ہو سکی۔ دوبارہ کوشش کریں۔",
    err_too_many: "بہت زیادہ کوششیں۔ بعد میں کوشش کریں۔",
  },
};

/** Returns the document checklist based on nationality + marital + applicant_type. */
export function docChecklist(nationality, marital, applicant_type, T) {
  const items = [];
  if (nationality === "saudi") {
    items.push({ key: "passport", label: T.doc_passport, required: true });
    items.push({ key: "national_id", label: T.doc_national_id, required: true });
    items.push({ key: "bank", label: T.doc_bank, required: true });
    items.push({ key: "photo", label: T.doc_photo, required: true });
    items.push({ key: "old_visas", label: T.doc_old_visas, required: false });
    if (marital === "married" || applicant_type === "family") {
      items.push({ key: "family_card", label: T.doc_family_card, required: true });
    }
  } else {
    // non_saudi (resident OR foreign visitor)
    items.push({ key: "passport", label: T.doc_passport, required: true });
    items.push({ key: "residence", label: T.doc_residence, required: true });
    items.push({ key: "bank6", label: T.doc_bank6, required: true });
    items.push({ key: "salary", label: T.doc_salary, required: true });
    items.push({ key: "photo", label: T.doc_photo, required: true });
    items.push({ key: "exit_return", label: T.doc_exit_return, required: true });
    items.push({ key: "old_visas", label: T.doc_old_visas, required: false });
    if (marital === "married" || applicant_type === "family") {
      items.push({ key: "marriage", label: T.doc_marriage, required: true });
    }
  }
  return items;
}
